export default __webpack_public_path__ + "static/media/378.86ca70a6.png";